export const convertDotsToUnderscores = (str: string) =>
  str ? str.replace(/\./g, "_") : str;
